import React from 'react';
import Header from './Header';

const Header_InnerPages = (props) => {
    return (
        <section className='bg-privacy-policy-top mb-3'>
            <Header />
            <div className='container px-5'>
                <div className='row px-3'>
                    <div className='col-lg-12  my-4 text-center'>
                        <p className='text-white f-72 my-5 f-pop-med'>{props.pageName}</p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Header_InnerPages;